// extracted by mini-css-extract-plugin
export default {"search-wrapper":"aAHcr","search":"u7zG6"};